import React, { useState, useEffect } from "react";
import { colors } from "../../../../../themes/Colors";
import useWindowDimensions from "../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
} from "../../../../common-components";
import LinkedUserCard from "./linked-user-card/LinkedUserCard";
import SearchBar from "../../../../common-components/search-bar/SearchBar";
import InviteLinkedUsers from "./invite-linked-users/InviteLinkedUsers";

const LinkedPopUpDisplay = ({
  display,
  companyInformation,
  loading,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
  onCloseClick,
}) => {
  const { width, height } = useWindowDimensions();
  const [displayView, setDisplayView] = useState("users");
  const [inviteEmail, setInviteEmail] = useState("");
  const [invitePin, setInvitePin] = useState("");

  const [linkedInvites, setLinkedInvites] = useState([]);
  const [linkedUsers, setLinkedUsers] = useState([]);

  const [selectedRole, setSelectedRole] = useState("");
  const SendInvite = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/createInviteAndSend",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            email: inviteEmail,
            roles: [selectedRole],
            linkedId: auth.userId,
            linkedBrand: "DRIVERS FRIEND CORE",
            createdBy: auth.firstName + " " + auth.lastName,
            pin: invitePin,
            type: "mobileUser",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.message) {
        setLoading(false);
        setToastPop(true);
        setMessage("You have succesfully sent the invite");
        setPopUpTitle("SUCCESS");
        setDisplayView("users");
        // setInvitesArray(respnseData.invites);
        // setToastPop(true);
      } else {
        setLoading(false);
        setToastPop(true);
        setMessage("An error has occured");
        setPopUpTitle("FAILURE");
        // setInvitesArray(respnseData.invites);
      }
    } catch (err) {
      setLoading(false);
      setToastPop(true);
      setMessage("An error has occured");
      setPopUpTitle("FAILURE");

      console.log("error", err);
    }
  };

  const GetLinkedUsers = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getlinkedUsers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth ? auth.userId : null,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.linkedUsers) {
        setLinkedUsers(respnseData.linkedUsers);
        // setInvitesArray(respnseData.invites);
        // setToastPop(true);
      }
      // else {
      //     setLoading(false);
      //     setToastPop(true);
      //     setMessage("An error has occured");
      //     setPopUpTitle("FAILURE");
      //     // setInvitesArray(respnseData.invites);
      //   }
    } catch (err) {
      setToastPop(true);
      setMessage("An error has occured");
      setPopUpTitle("FAILURE");

      console.log("error", err);
    }
  };

  const GetPendingLinkedUsers = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL +
          "/userInvites/getlinkedPendingUsers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth ? auth.userId : null,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.linkedUsers) {
        setLinkedInvites(respnseData.linkedUsers);
        // setInvitesArray(respnseData.invites);
        // setToastPop(true);
      }
      // else {
      //     setLoading(false);
      //     setToastPop(true);
      //     setMessage("An error has occured");
      //     setPopUpTitle("FAILURE");
      //     // setInvitesArray(respnseData.invites);
      //   }
    } catch (err) {
      setToastPop(true);
      setMessage("An error has occured");
      setPopUpTitle("FAILURE");

      console.log("error", err);
    }
  };

  useEffect(() => {
    GetPendingLinkedUsers();
    GetLinkedUsers();
  }, [loading]);
  return (
    <div
      style={{
        position: "absolute",
        minWidth: display ? 400 : 0,
        width: display ? 400 : 0,
        minHeight: height - 60,
        height: height - 60,
        backgroundColor: colors.white,
        right: 0,
        zIndex: 20000,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        WebkitBoxShadow: "0px 0px 7px 2px #00000030",
      }}
    >
      <div style={{ position: "absolute", top: 10, left: 10 }}>
        <BaseButtons
          label={"X"}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          onClick={onCloseClick}
          width={40}
        />
      </div>
      <div
        style={{
          minHeight: 60,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          fontWeight: "bold",
          fontSize: 18,
        }}
      >
        LINKED USERS
      </div>
      <div
        style={{
          minHeight: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          fontWeight: "bold",
          backgroundColor: colors.primaryBlue50,
          display: "flex",
        }}
      >
        <BaseButtons
          label={"APPROVED"}
          width={"50%"}
          backgroundColor={
            displayView === "users"
              ? colors.primaryBlue
              : colors.secondaryDarkBlue
          }
          onClick={() => setDisplayView("users")}
        />
        <BaseButtons
          label={"INVITES"}
          width={"50%"}
          backgroundColor={
            displayView === "invites"
              ? colors.primaryBlue
              : colors.secondaryDarkBlue
          }
          onClick={() => setDisplayView("invites")}
        />
      </div>
      <div
        style={{
          minHeight: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          fontWeight: "bold",
          backgroundColor: colors.primaryBlue50,
          display: "flex",
        }}
      >
        <BaseButtons
          label={"INVITE NEW USER"}
          width={"100%"}
          backgroundColor={
            displayView === "addUser"
              ? colors.primaryBlue
              : colors.secondaryDarkBlue
          }
          onClick={() => setDisplayView("addUser")}
        />
      </div>
      {displayView === "addUser" ? null : (
        <div style={{ width: "100%" }}>
          <SearchBar width={"100%"} size={"100%"} />
        </div>
      )}
      {displayView === "users" ? (
        <div
          style={{
            height: height - 250,
            // borderStyle: "solid",
            width: "100%",
            overflowY: "scroll",
            scrollbarWidth: "thin",
            overflowX: "hidden",
          }}
        >
          <div style={{ minHeight: 10 }} />
          {linkedUsers.length >= 1
            ? linkedUsers.map((user, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <LinkedUserCard
                      linkedUserName={user.username}
                      contactInfo={user.contactNumber}
                      access={user.role}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
      {displayView === "invites" ? (
        <div
          style={{
            height: height - 250,
            // borderStyle: "solid",
            width: "100%",
            overflowY: "scroll",
            scrollbarWidth: "thin",
            overflowX: "hidden",
          }}
        >
          <div style={{ minHeight: 10 }} />
          {linkedInvites.length >= 1
            ? linkedInvites.map((user, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <InviteLinkedUsers
                      linkedUserName={user.username}
                      status={user.status}
                      role={user.role}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
      {displayView === "addUser" ? (
        <div
          style={{
            height: height - 250,
            // borderStyle: "solid",
            width: "99%",
            overflowY: "scroll",
            scrollbarWidth: "thin",
            overflowX: "hidden",
            zIndex: 200,
            // position: "absolute",
            // top: 140,
            backgroundColor: colors.white,
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            <div>
              <TextInputField
                labelTitle={"EMAIL"}
                mini={true}
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
              />
              <TextInputField
                labelTitle={"PIN"}
                mini={true}
                value={invitePin}
                onChange={(e) => setInvitePin(e.target.value)}
              />

              <div
                style={{
                  marginTop: 20,
                  marginBottom: 15,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                SELECT ROLES
              </div>
              <div style={{ width: 250, fontSize: 12, marginBottom: 10 }}>
                Depending on the role assigend to invites user they will gain
                access to different actions and modules
              </div>
              <CheckInput
                label={"DRIVER"}
                selected={selectedRole === "DRIVER"}
                onClick={() => setSelectedRole("DRIVER")}
              />
              <div style={{ minHeight: 6 }} />
              <CheckInput
                label={"VIEW"}
                selected={selectedRole === "FAMILY"}
                onClick={() => setSelectedRole("FAMILY")}
              />
              <div style={{ minHeight: 6 }} />
              <CheckInput
                label={"FAMILY"}
                selected={selectedRole === "FRIEND"}
                onClick={() => setSelectedRole("FRIEND")}
              />
              <div style={{ minHeight: 6 }} />
              <CheckInput
                label={"MANAGE"}
                selected={selectedRole === "AGENT"}
                onClick={() => setSelectedRole("AGENT")}
              />
              <div style={{ minHeight: 6 }} />
              <CheckInput
                label={"AGENT"}
                selected={selectedRole === "AGENT"}
                onClick={() => setSelectedRole("AGENT")}
              />
              <div style={{ minHeight: 15 }} />
              {displayView === "addUser" ? (
                <BaseButtons
                  label={"SEND INVITE"}
                  width={"100%"}
                  backgroundColor={colors.greenLight}
                  borderRadius={8}
                  onClick={() => SendInvite()}
                />
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default LinkedPopUpDisplay;
